<script setup>
import { computed, ref } from 'vue';

const emit = defineEmits(['submeter']);

const props = defineProps({
    id: {
        type: [Number, String],
        required: false,
    },
    idsolicitacao: {
        type: [Number, String],
        required: false,
    },
    tipoSolicitacao: {
        type: String,
        required: false,
    },
    tipoCadastro: {
        type: String,
        required: false,
    },
    descricao: {
        type: String,
        required: false,
    },
    podeRascunho: {
        type: Boolean,
        default: false,
    },
    carregamento: {
        type: Boolean,
        default: false,
    },
    carregamentoSubmit: {
        type: Boolean,
        default: false,
    },
    temTutorial: {
        type: Boolean,
        default: true,
    },
    tutorialPassos: {
        type: Array,
        default: () => [],
    },
    labelSubmit: {
        type: String,
        default: 'Enviar Solicitação',
    },
    envioTutorialTitulo: {
        type: String,
        default: 'Submeter',
    },
    envioTutorialDescricao: {
        type: String,
        default: 'Após preencher todos os campos, clique aqui para submeter o formulário.',
    },
    disabledSubmit: {
        type: Boolean,
        default: false,
    },
    comCabecalho: {
        type: Boolean,
        default: true,
    },
    returnTrailRota: {
        type: String,
        default: 'rotaAnterior',
    },
    // Telas com estados sem envio (ex.: formulário já respondido) escondem o rodapé de ações
    exibirRodape: {
        type: Boolean,
        default: true,
    }
});

const passosComEnvio = computed(() => {
    return [
        ...props.tutorialPassos,
        {
            target: '#submeter',
            header: {
                title: props.envioTutorialTitulo,
            },
            content: props.envioTutorialDescricao,
            params: {
                placement: 'top',
                enableScrolling: false
            },
        },
    ];
});

const enviaFormulario = (isRascunho) => {
    emit('submeter', isRascunho);
};

const tour = ref(null);

const iniciarTour = () => {
    tour.value?.iniciar();
};
</script>

<template>
    <div class="relative">
        <TourGuiado ref="tour" :passos="passosComEnvio" />
        <CabecalhoCadastros v-if="props.comCabecalho" :idsolicitacao="props.idsolicitacao"
            :tipo-solicitacao="props.tipoSolicitacao" :tipo-cadastro="props.tipoCadastro" :descricao="props.descricao"
            @iniciarTour="iniciarTour" :tutorial="!props.carregamento && props.temTutorial" />

        <Carregador :carregando="props.carregamento" class="card flex justify-content-center mt-7 w-full">
            <form
                class="w-full mx-1 formgrid p-fluid bg-white pb-1 px-4 pt-4 lg:pt-6 border-round-2xl border-1 surface-border"
                :class="[props.comCabecalho ? 'mt-6' : '', props.exibirRodape ? '' : 'pb-5']"
                style="contain: inline-size;" @submit.prevent>

                <slot>
                </slot>

                <div v-if="props.exibirRodape" :class="[
                    'flex gap-3 field col-12 flex flex-column gap-9 lg:gap-0 md:flex-row border-top-1 surface-border mt-5 pt-5 px-0',
                    !props.podeRascunho ? 'justify-content-end' : 'justify-content-between'
                ]">
                    <BotaoRascunho v-if="props.podeRascunho" @click="enviaFormulario(true)"
                        :disabled="props.carregamentoSubmit || props.disabledSubmit" />

                    <div
                        class="flex flex-column md:flex-row gap-3 md:gap-6 justify-content-end align-items-center w-full md:w-auto">
                        <ReturnTrail :action="props.returnTrailRota" type="cancel" :disabled="props.carregamentoSubmit"
                            class="font-semibold text-500 hover:700 text-xs" />

                        <Button @click="enviaFormulario(false)" :disabled="props.carregamentoSubmit || props.disabledSubmit"
                            :label="props.labelSubmit" id="submeter" severity="success" size="small">
                            <template #icon>
                                <i v-if="props.carregamentoSubmit" class="pi pi-spin pi-spinner mr-3 "></i>
                            </template>
                        </Button>
                    </div>

                </div>
            </form>
        </Carregador>
    </div>
</template>